import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '抗击新冠，免费义诊——7x24小时在线问诊';

const route: RouteConfig = {
  path: '/20200210LHYZ',
  name: '20200210LHYZ',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
